const aiNine =[
    {
        "name": "盘古大模型",
        "url": "https://www.huaweicloud.com/product/pangu.html",
        icon: "images/pangu.svg",
        "description": "华为开发的通用型大模型，覆盖NLP、CV等领域，支持跨行业智能化解决方案，助力千行百业数字化转型。"
    },
    {
        "name": "Hugging Face",
        "url": "https://huggingface.co/",
        "icon": "images/DistilBERT.png",
        "description": "全球领先的AI开源平台，提供预训练模型、数据集和工具链，支持自然语言处理、计算机视觉等任务，降低AI开发门槛。",
        isVpn: true
    },
    {
        "name": "Codex",
        "url": "https://openai.com/index/openai-codex/",
        "icon": "images/qmruasgh98rw6a4u4yop.webp",
        "description": "OpenAI开发的代码生成模型，能将自然语言转为可执行代码，支持多种编程语言，广泛应用于编程辅助、自动化脚本生成等场景。"
    },
    {
        "name": "Imagen",
        "url": "https://imagen.research.google/",
        icon: "images/imagen-1.jpg",
        "description": "Google研发的文本到图像生成模型，支持高分辨率图像合成，擅长复杂文本描述的视觉化呈现，应用于创意设计、广告制作等领域。"
    },
    {
        "name": "LLaMA",
        "url": "https://github.com/facebookresearch/llama",
        icon: "images/llama-1.png",
        "description": "Meta发布的开源大语言模型，专注于自然语言理解与生成，支持多语言处理，为学术研究和企业级应用提供基础模型能力。",
        isVpn: true
    },
    {
        "name": "Lobe",
        "url": "https://github.com/lobe",
        "icon": "images/lobe-1.png",
        "description": "微软推出的低代码机器学习工具，支持图像、文本、音频模型训练，无需编程基础即可快速构建AI模型，适合中小企业和开发者。",
        isVpn: true
    },
    {
        "name": "Scale",
        "url": "https://scale.com/",
        "icon": "images/scale-2.jpg",
        "description": "AI数据服务平台，提供数据标注、模型训练优化等服务，加速企业AI项目落地，覆盖计算机视觉、自然语言处理等领域。"
    },
    {
        "name": "Evidently AI",
        "url": "https://www.evidentlyai.com/",
        "icon": "images/evidently-1.png",
        "description": "开源的机器学习监控工具，支持模型性能评估、数据漂移检测和可视化分析，保障AI系统稳定运行。"
    },
    {
        "name": "AnimateDiff",
        "url": "https://github.com/guoyww/AnimateDiff",
        "icon": "images/AnimateDiff.png",
        "description": "基于Stable Diffusion的动画生成框架，通过AI技术生成连贯动画序列，推动AI在动画制作和视频生成领域的应用。"
    },
    {
        "name": "Civitai",
        "url": "https://civitai.com/",
        "icon": "images/civitai-icon-filled-36.png",
        "description": "AI模型分享社区，用户可上传、下载预训练模型（如Stable Diffusion checkpoint），促进模型资源共享与复用。",
        isVpn: true
    },
    {
        "name": "Kaggle",
        "url": "https://www.kaggle.com/",
        icon: "images/kaggle.png",
        "description": "全球最大的AI和机器学习社区，提供数据竞赛、数据集、Notebook环境，助力开发者学习、实践和分享AI技术。"
    },
    {
        "name": "Coze",
        "url": "https://www.coze.cn/",
        icon: "images/coze.png",
        "description": "AI聊天机器人构建平台，支持可视化流程设计、多模态交互，无需代码即可创建智能客服、助手等应用。"
    },
    {
        "name": "腾讯混元",
        "url": "https://hunyuan.tencent.com/",
        "icon": "images/txhy.jpeg",
        "description": "腾讯研发的大语言模型，具备多领域知识理解和生成能力，支持智能问答、内容创作、代码辅助等场景。"
    },
    {
        "name": "Gradio",
        "url": "https://www.gradio.app/",
        icon: "images/Gradio.png",
        "description": "开源的机器学习演示工具，支持快速构建和分享模型 demo，降低AI应用部署门槛，促进技术交流。"
    },
    {
        "name": "中国大模型大全",
        "url": "https://github.com/wgwang/awesome-LLMs-In-China",
        "icon": "images/llms.png",
        "description": "汇总国内大模型信息的平台，收录多领域大模型的技术特点、应用场景及官方链接，提供一站式查询服务。",
        isVpn: true
    },
    {
        "name": "始智AI",
        "url": "https://www.wisemodel.cn/models",
        "icon": "images/shizhi.png",
        "description": "AI开源社区，聚焦技术交流与协作，提供开源模型、工具和项目案例，推动AI技术普惠。"
    },
    {
        "name": "Oasis",
        "url": "https://oasis-model.github.io/",
        "icon": "images/oasis-1.png",
        "description": "AI驱动的实时游戏生成平台，支持用户通过文本输入创建互动游戏，探索AI在游戏开发领域的新可能。"
    },
    {
        "name": "FLUX",
        "url": "https://www.flux.ai/p",
        "icon": "images/FLUX.png",
        "description": "开源的生成式AI模型，专注于图像生成与创意设计，支持自定义风格和参数调整，提供高效的视觉内容解决方案。"
    },
    {
        "name": "Sora",
        "url": "https://sora.com/",
        "icon": "images/Sora-Logo.png",
        "description": "OpenAI开发的视频生成工具，支持文本驱动视频创作，实现人物动作、场景生成等功能，引领AI视频技术突破。",
        isVpn: true
    },
    {
        "name": "火山方舟",
        "url": "https://www.volcengine.com/product/ark",
        "icon": "images/huoshan.png",
        "description": "字节跳动推出的大模型服务平台，提供模型训练、部署、优化一站式服务，助力企业快速落地大模型应用。"
    },
    {
        "name": "魔搭社区",
        "url": "https://modelscope.cn/home",
        "icon": "images/modashequ.png",
        "description": "阿里达摩院开源平台，提供海量预训练模型和开发工具，支持NLP、CV等多领域任务，推动AI模型共建共享。"
    },
    {
        "name": "文心大模型",
        "url": "https://wenxin.baidu.com/",
        "icon": "images/wenxindamoxing.jpg",
        "description": "百度研发的大语言模型，深度融合中文语境，支持智能问答、内容生成、多模态交互，广泛应用于智能客服、知识图谱等场景。"
    },
    {
        "name": "Ollama",
        "url": "https://ollama.com/",
        "icon": "images/ollama-logo.png",
        "description": "开源的本地大语言模型运行工具，支持在个人设备上部署LLM，保障数据隐私，降低模型使用门槛。"
    },
    {
        "name": "AnythingLLM",
        "url": "https://anythingllm.com",
        "icon": "images/AnythingLLM-icon.png",
        "description": "全栈AI应用框架，提供模型集成、API管理、可视化界面，帮助开发者快速构建跨平台AI应用。"
    },
    {
        "name": "Cherry Studio",
        "url": "https://cherry-ai.com/",
        "icon": "images/cherry-ai.png",
        "description": "多模型管理平台，支持快速切换ChatGPT、Stable Diffusion等模型，提供统一交互界面，提升AI工具使用效率。"
    }
]

export default aiNine
